import React from "react";
import { Fragment } from "react";
import ReactSwipeable from "react-swipeable";
import { FlexBox } from "scuid-x";
import ActiveButtonImage from "../assets/images/carousel-blue-button.svg";
import InactiveButtonImage from "../assets/images/carousel-gray-button.svg";
import { DocExample, DocExamples } from "../constants/DocExamples";
import { DocType } from "../constants/DocType";
import "./DocExampleCarousel.css";

export interface DocExampleCarouselProps {
  docType: DocType;
}

export interface DocExampleCarouselState {
  examples: DocExample[];
  index: number;
}

export class DocExampleCarousel extends React.Component<DocExampleCarouselProps, DocExampleCarouselState> {

  constructor(props: DocExampleCarouselProps) {
    super(props);
    this.state = {
      examples: DocExamples.getByDocType(props.docType),
      index: 0,
    };
  }

  public render() {
    const { examples, index } = this.state;
    if (examples.length === 0) {
      return (null);
    }

    const exampleInfo = examples[index].info;

    const carouselCard = (
        <Fragment key={exampleInfo.title}>
          <h4 className={"docExampleCarousel-image-title"}>{exampleInfo.title}</h4>
          <ReactSwipeable
            preventDefaultTouchmoveEvent={true}
            onSwipedLeft={this.swipedLeft}
            onSwipedRight={this.swipedRight}
          >
            <div className={"docExampleCarousel-image-container"}>
              <div className={"docExampleCarousel-image-border-left"}/>
              <div className={"docExampleCarousel-image-border-top"}/>
              <div className={"docExampleCarousel-image-border-right"}/>
              <div className={"docExampleCarousel-image-border-bottom"}/>
              <img
                className={"docExampleCarousel-image"}
                src={exampleInfo.image}
              />
            </div>
          </ReactSwipeable>
        </Fragment>
    );

    let carouselButtons;
    if (examples.length === 1) {
      carouselButtons = (null);
    } else {
      carouselButtons = examples.map( (example, i) => (
        <img
          className={"docExampleCarousel-button"}
          src={i === index ? ActiveButtonImage : InactiveButtonImage}
          onClick={this.carouselButtonClick.bind(this, i)}
          key={example.info.title}
        />
      ));
    }

    return (
      <div className={"docExampleCarousel"}>
        {carouselCard}
        <FlexBox
          className={"docExampleCarousel-button-container"}
          justifyContent="center"
          alignItems="center"
        >
          {carouselButtons}
        </FlexBox>
      </div>
    );
  }

  private carouselButtonClick = (index: number): void => {
    this.setState({
      index,
    });
  };

  private swipedLeft = (event: any, delta: number, isFlick: boolean): void => {
    if (delta > 10 && this.state.index < this.state.examples.length - 1) {
      this.setState({
        index: this.state.index + 1,
      });
    }
  };

  private swipedRight = (event: any, delta: number, isFlick: boolean): void => {
    if (delta < -10 && this.state.index > 0) {
      this.setState({
        index: this.state.index - 1,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/DocExampleCarousel.tsx